import { useGetCompanyGroups } from 'entities/company/api/hooks';
import { atom, useAtom } from 'jotai';
import { useEffect } from 'react';

const groupsAtoms = atom<string[]>([]);

/**
 * Hook to manage contact groups.
 */
export const useContactGroups = () => {
  const [groups, setGroups] = useAtom(groupsAtoms);

  /**
   * Fetches company groups using the custom hook.
   */
  const { data: apiGroups, isLoading, refetch } = useGetCompanyGroups();

  /**
   * Effect to update the group state when apiGroups changes.
   */
  useEffect(() => {
    setGroups(apiGroups?.map(g => g.name) || []);
  }, [apiGroups, setGroups]);

  /**
   * Add groups to the state.
   */
  const add = (item: string | string[]) => {
    const newGroups = Array.isArray(item) ? item : [item];

    const updateFunction = (prevGroups: string[]) => {
      const uniqueNewGroups = newGroups.filter(
        group => !prevGroups.includes(group),
      );
      return [...prevGroups, ...uniqueNewGroups];
    };

    setGroups(updateFunction);
  };

  return {
    add,
    groups,
    isLoading,
    refetch,
  };
};
